import {ColumnTypeEnumeration} from './column-type.enumeration';
import {DatatableColumn} from './datatable-column';

export interface IconConfig {
  defaultIcon?: string;
  multipleIcons?: {
    [key: string]: {
      icon: string;
      cssClass?: string;
    }
  };
  checkField?: string;
}

export class ActionColumn extends DatatableColumn {
  iconConfig?: IconConfig;
  onClick?: (rowData: any) => void;
  isVisible?: (rowData: any) => boolean;

  constructor(name: string, label: string, onClick: (rowData: any) => void, iconConfig: IconConfig, isVisible?: (rowData: any) => boolean) {
    super(name, label);
    this.name = name;
    this.iconConfig = iconConfig;
    this.label = label;
    this.onClick = onClick;
    this.type = ColumnTypeEnumeration.ACTION_COLUMN;
    this.sortable = false;
    this.isVisible = isVisible;
  }
}
